const byBirth = (a, b) => (a.birth_year || 9999) - (b.birth_year || 9999);
const hasOrder = (p) => p.sibling_order !== null && p.sibling_order !== undefined;
export const bySiblingOrder = (a, b) =>
  hasOrder(a) && hasOrder(b) ? a.sibling_order - b.sibling_order : hasOrder(a) ? -1 : hasOrder(b) ? 1 : byBirth(a, b);

export function buildTree(persons) {
  const byId = Object.fromEntries(persons.map((p) => [p.person_id, p]));
  const children = {};
  persons.forEach((p) => p.parent_ids.forEach((pid) => (children[pid] ||= []).push(p.person_id)));
  const childrenOf = (id) => (children[id] || []).map((c) => byId[c]).sort(bySiblingOrder);
  const spousesOf = (id) => (byId[id]?.spouse_ids || []).map((s) => byId[s]).filter(Boolean);
  return { byId, childrenOf, spousesOf };
}

export function findRoots(persons, t) {
  const used = new Set();
  const roots = [];
  [...persons].sort(byBirth).forEach((p) => {
    if (p.parent_ids.length || used.has(p.person_id)) return;
    const spouses = t.spousesOf(p.person_id);
    if (spouses.some((s) => s.parent_ids.length)) return;
    used.add(p.person_id);
    spouses.forEach((s) => used.add(s.person_id));
    roots.push(p);
  });
  return roots;
}

export function ancestorLevels(id, t) {
  const levels = [];
  const seen = new Set([id]);
  let current = [id];
  while (current.length) {
    const next = [];
    current.forEach((cid) =>
      (t.byId[cid]?.parent_ids || []).forEach((pid) => {
        if (!seen.has(pid) && t.byId[pid]) { seen.add(pid); next.push(pid); }
      })
    );
    if (next.length) levels.push(next.map((n) => t.byId[n]));
    current = next;
  }
  return levels;
}

export function descendantIds(id, t, acc = new Set()) {
  [id, ...t.spousesOf(id).map((s) => s.person_id)].forEach((pid) =>
    t.childrenOf(pid).forEach((c) => {
      if (!acc.has(c.person_id)) { acc.add(c.person_id); descendantIds(c.person_id, t, acc); }
    })
  );
  return acc;
}

export const branchTotal = (id, tree, map) => {
  const ids = new Set([id, ...tree.spousesOf(id).map((s) => s.person_id)]);
  descendantIds(id, tree).forEach((d) => {
    ids.add(d);
    tree.spousesOf(d).forEach((s) => ids.add(s.person_id));
  });
  let total = 0;
  let counted = 0;
  ids.forEach((i) => { if (map[i]) { total += map[i].amount; counted += 1; } });
  return { total, counted, members: ids.size };
};

export const initials = (name = "") => name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
export const years = (p) => (p.birth_year ? `${p.birth_year}${p.death_year ? ` – ${p.death_year}` : ""}` : p.death_year ? `d. ${p.death_year}` : "");
